export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12599.eb32c16b.jpg";